// extracted by mini-css-extract-plugin
export default {"search-container":"SearchPOI_search-container__akd+w","search-input":"SearchPOI_search-input__XCzHI","search-button":"SearchPOI_search-button__4S34N"};